import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import EditorialContainer from 'brastrap/editorial/editorial-container/EditorialContainer';
import Banner from '../Banner';
import { Next, ChatToAFitter } from '../ControlButtons';
import {
  dataLayerGA4HyperlinksInText,
  dataLayerGA4SizeQuizStageNumber,
  dataLayerGA4UserSize,
} from '../../../shared/utils/data-layer';

const Stage12 = ({
  backChange,
  backSize,
  basePath,
  contactData,
  country,
  cupChange,
  cupSize,
  defaultNextProps,
  displayQuiz,
  finalAdjustment,
  intl: { formatMessage, locale },
  messages,
  resetAllChanges,
  convertFromUSToUKSize,
}) => {
  const [ukCupSize, setUKCupSize] = useState(null);

  const STAGE_NUMBER = '12';
  const cupSizeToUse = finalAdjustment(backChange, country, cupChange, cupSize);

  useEffect(() => {
    window.scrollTo(0, 0);
    dataLayerGA4SizeQuizStageNumber(STAGE_NUMBER);
    dataLayerGA4UserSize(STAGE_NUMBER, backSize, cupSizeToUse);

    if (locale === 'en-US' && country === 'en-US') {
      setUKCupSize(convertFromUSToUKSize(cupSizeToUse));
    } else {
      setUKCupSize(cupSizeToUse);
    }
  }, []);

  return (
    <div className="stage stage-final">
      <div className="wrap">
        <p>{formatMessage(messages.finalpara1)}</p>

        <Banner
          stageNumber={STAGE_NUMBER}
          locale={locale}
          message={`${[backSize, ukCupSize].join(' ')} ${
            locale === 'en-US' ? '(UK Sized)' : ''
          }`.trimEnd()}
        />

        <p>{formatMessage(messages.finalpara2)}</p>

        <Next
          id="shop-by-size__CTA"
          disabled={false}
          {...defaultNextProps(0, formatMessage(messages.shopMySize))}
          customFunc={() => {
            resetAllChanges();
            window.location.href = `${basePath}shop-by/size/${backSize}${ukCupSize.toLowerCase()}-bras`;
          }}
        />

        <p className="stage-final__paragraph">
          <p className="sub-header">
            {formatMessage(messages.finalpara3)}{' '}
            <a
              onClick={() => dataLayerGA4HyperlinksInText(STAGE_NUMBER)}
              href={`tel:${formatMessage(messages.phone)}`}
            >
              {formatMessage(messages.phone)}
            </a>{' '}
            {formatMessage(messages.finalpara3or)}
          </p>
        </p>

        <ChatToAFitter stage={STAGE_NUMBER} />

        {displayQuiz && (
          <div
            className="c-footer__channels"
            onClick={() => {
              document
                .getElementsByClassName('c-modal__container')[0]
                .classList.add('background');
            }}
          >
            <EditorialContainer containers={contactData} />
          </div>
        )}

        <hr className="finalStageDivider" />

        <div className="customerQuoteMainContainer">
          <div className="customerQuoteContainer">
            <p className="contentHeader">
              You deserve a fit that feels good, just like these women…
            </p>
            <p className="customerQuoteText">
              “I was <b>amazed</b> to find out I was a 36H when I’d been wearing
              a 38E. What surprised me even more was how much more{' '}
              <b>confident</b> I felt wearing a bra that <b>fitted me!</b>” -
              Hanna
            </p>
            <p className="customerQuoteText">
              “Going from a 40C to a 36F I was dubious but they fit like a{' '}
              <b>DREAM!</b>” - Charlotte
            </p>
            <p className="customerQuoteText">
              “I was measured for the first time at Bravissimo and was wearing a
              34B for 25 years, I&apos;m actually a 30F - it&apos;s{' '}
              <b>changed my life!</b>” - Lisa
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(Stage12);

Stage12.propTypes = {
  backChange: PropTypes.number,
  backSize: PropTypes.string,
  Banner: PropTypes.func,
  basePath: PropTypes.string,
  celebration: PropTypes.string,
  contactData: PropTypes.array,
  country: PropTypes.string,
  cupChange: PropTypes.number,
  cupSize: PropTypes.string,
  defaultNextProps: PropTypes.func,
  displayQuiz: PropTypes.bool,
  EditorialContainer: PropTypes.func,
  finalAdjustment: PropTypes.func,
  intl: intlShape,
  messages: PropTypes.object,
  Next: PropTypes.func,
  resetAllChanges: PropTypes.func,
  convertFromUSToUKSize: PropTypes.func,
};
